import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { ROLE_CODES } from '@/config/role-codes';
import { useAccessControl } from '@/contexts/AccessContext';
import { logout } from '@/services/Login/auth';

export const useLogout = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { activeRoleCode } = useAccessControl();

  const handleLogout = useCallback(async () => {
    if (isLoggingOut) return;

    setIsLoggingOut(true);
    try {
      const response = await logout();
      if (response.statusCode === 200) {
        const loginPath =
          activeRoleCode === ROLE_CODES.EXTERNAL_AUDITOR ? '/external-auditor' : '/login';
        window.location.replace(loginPath);
        return;
      }
      toast.error(
        typeof response.status === 'string' ? response.status : 'Logout failed. Please try again.'
      );
      setIsLoggingOut(false);
    } catch {
      toast.error('Logout failed. Please try again.');
      setIsLoggingOut(false);
    }
  }, [activeRoleCode, isLoggingOut]);

  return { isLoggingOut, handleLogout };
};
